import { LModalContentsWidthType, ModalType } from '@lib/components';
import { ModalBlockParts } from '@lib/services';
import { ConsiderationSupportDetailsModalComponent } from './consideration-support-details-modal.component';
import { GetOrderResponseData } from 'src/sdk-servicing';

export interface ConsiderationSupportDetailsPayload extends GetOrderResponseData {}
/**
 * 配慮系サポート詳細モーダル表示(G01-M011)をモーダル表示する
 * モーダル呼出しパラメータ
 * const part = considerationSupportDetailsModalPayloadParts()
 * this.modal.showSubModal(part)
 */
export function considerationSupportDetailsModalPayloadParts(order?: GetOrderResponseData): ModalBlockParts {
  return {
    id: 'ConsiderationSupportDetailsModalComponent',
    block: ConsiderationSupportDetailsModalComponent,
    closeBackEnable: false,
    type: ModalType.TYPE1,
    modalWidth: LModalContentsWidthType.MODAL_TAB_W384,
    payload: { ...order } as ConsiderationSupportDetailsPayload,
  };
}
